import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, FileText, ScrollText, HeartHandshake, Sparkles } from "lucide-react";

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "");

const ICON = { match: HeartHandshake, combined: FileText, kundli: ScrollText, dosha: Sparkles };

export default function MyReports() {
  const [reports, setReports] = useState(null);

  useEffect(() => { api.get("/vedic/reports/mine").then((r) => setReports(r.data)).catch(() => setReports([])); }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-12 max-w-5xl mx-auto py-12" data-testid="my-reports-page">
      <div className="flex items-end justify-between mb-6">
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-accent font-semibold mb-1">Your Library</p>
          <h1 className="font-serif text-3xl font-bold">My Reports</h1>
          <p className="text-muted-foreground mt-1">Re-download your Kundli, Dosha and Matchmaking PDFs anytime.</p>
        </div>
        <Link to="/vedic-services/kundli"><Button variant="outline" className="rounded-full border-accent text-primary hidden sm:inline-flex">New report</Button></Link>
      </div>

      {reports === null ? (
        <p className="text-muted-foreground py-16 text-center" data-testid="reports-loading">Loading your reports…</p>
      ) : reports.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-12 text-center" data-testid="reports-empty">
          <FileText className="h-10 w-10 mx-auto text-muted-foreground/50 mb-3" />
          <p className="text-muted-foreground">You have no reports yet.</p>
          <Link to="/vedic-services/kundli"><Button className="mt-5 rounded-full bg-primary text-primary-foreground">Generate your first report</Button></Link>
        </div>
      ) : (
        <div className="space-y-4">
          {reports.map((r) => {
            const Icon = ICON[r.report_type === "match" ? "match" : (r.downloads.find((d) => d.kind === "combined") ? "combined" : r.downloads[0]?.kind)] || FileText;
            return (
              <div key={r.report_id} data-testid={`report-row-${r.report_id}`} className="rounded-2xl border border-border bg-card p-5 flex flex-col sm:flex-row sm:items-center gap-4">
                <span className="h-11 w-11 grid place-items-center rounded-xl bg-gradient-to-br from-accent/20 to-primary/20 text-primary shrink-0"><Icon className="h-5 w-5" /></span>
                <div className="flex-1">
                  <h3 className="font-serif text-lg font-semibold">{r.title}</h3>
                  <p className="text-sm text-muted-foreground">{r.name} · {fmtDate(r.created_at)} · {r.total === 0 ? "Free" : `₹${r.total}`}</p>
                </div>
                <div className="flex flex-wrap gap-2">
                  {r.downloads.map((d) => (
                    <a key={d.kind} href={d.url} target="_blank" rel="noreferrer" data-testid={`report-download-${r.report_id}-${d.kind}`}>
                      <Button variant="outline" size="sm" className="rounded-full border-accent text-primary"><Download className="h-3.5 w-3.5 mr-1.5" /> {d.title}</Button>
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
